
import { writable } from 'svelte/store'

export type Breadcrumb = {
  label: string
  path: string
}


const store = writable<Breadcrumb[]>([])
export {store as breadcrumbs_store}


export const BreadcrumbsManager = {
	// Set entirely new breadcrumb trail
	set: (breadcrumbs: Breadcrumb[]) => store.set(breadcrumbs),
    
	// Add a new breadcrumb to the end
	add: (breadcrumb: Breadcrumb) => {
		store.update(crumbs => [...crumbs, breadcrumb])
	},

	// Remove last breadcrumb
	pop: () => {
		store.update(crumbs => crumbs.slice(0, -1))
	},

	// Clear all breadcrumbs
	clear: () => {
		store.set([])
		console.log('BreadcrumbsManager.clear()')
	},

	// Update breadcrumb at specific index
	updateAt: (index: number, breadcrumb: Breadcrumb) => {
		store.update(crumbs => {
			const newCrumbs = [...crumbs]
			newCrumbs[index] = breadcrumb
			return newCrumbs
		})
	}
}


